/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from './enums';
import {diplomatObjectSchema} from './diplomat-object';
import i18n from '../i18n';
import {ArchiveTriggerType} from './diplomat/enums/ArchiveTriggerType';

export const ArchiveSettings = diplomatObjectSchema.shape({
   trigger: yup.string().oneOf(ArchiveTriggerType.keys),
   daysToKeep: yup.number().integer().positive(i18n.t("Can't be less than zero")),
   delete: yup.boolean(),
   deleteSource: yup.boolean(),
   destinationTemplate: yup.string(),
   inboundFileType: yup.string().oneOf(enums.archiveFileType.keys),
   location: yup.string(),
   outboundFileType: yup.string().oneOf(enums.archiveFileType.keys),
   overwrite: yup.boolean(),
   skip: yup.boolean(),
   sourceTemplate: yup.string(),
   useTransaction: yup.boolean(),
   zip: yup.boolean(),
   zipTemplate: yup.string(),
});
export type IArchiveSettings = yup.InferType<typeof ArchiveSettings>;
